import HelpIcon from "@mui/icons-material/InfoOutlined";
import {
  Button,
  IconButton,
  Stack,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { IssueRelation } from "../../shared/CaseModel";
import { DialogShell } from "../general/DialogShell";
import { OrdinalBadge } from "./IssueRows";

export const IssueGroupHeaderRow = ({
  ordinal,
  relation,
  groupedOrdinals,
}: {
  ordinal: string;
  relation: IssueRelation;
  groupedOrdinals: string[];
}) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: "case.claims.issues",
  });
  const [infoOpen, setInfoOpen] = useState(false);
  return (
    <TableRow>
      <TableCell colSpan={2} sx={{ borderBottom: "none", pb: 0 }}>
        <Stack direction="row" spacing={1.25} sx={{ alignItems: "center" }}>
          <OrdinalBadge>{ordinal}</OrdinalBadge>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {t("header.group")}
          </Typography>
          <Tooltip title={t("groups.tip.info")}>
            <IconButton
              size="small"
              aria-label={t("groups.tip.info")}
              onClick={() => setInfoOpen(true)}
            >
              <HelpIcon fontSize="inherit" />
            </IconButton>
          </Tooltip>
        </Stack>

        <DialogShell
          open={infoOpen}
          onClose={() => setInfoOpen(false)}
          title={t(`groups.infoDialog.title.${IssueRelation[relation]}`)}
          description={
            <Trans
              i18nKey={`case.claims.issues.groups.infoDialog.description.${IssueRelation[relation]}`}
              components={{ bold: <b /> }}
              values={{
                groupedOrdinals: groupedOrdinals.join(", "),
                ordinal,
              }}
              count={2}
            />
          }
          actions={
            <Button
              onClick={() => setInfoOpen(false)}
              variant="contained"
              autoFocus
            >
              {t("groups.infoDialog.submit")}
            </Button>
          }
        />
      </TableCell>
    </TableRow>
  );
};
